import { Component, OnInit } from "@angular/core"
import { Location } from '@angular/common';
import { AppService } from '../../../app.service';
import { FilterPipe } from '../pipes/filter.pipe';
import { NewImplementTemplate, ImplementComponentType, TemplateAccess, ImplementCategory, ImplementTemplate } from '../entities/implement-template.model';
import { ImplementTemplateService } from '../services/implement-template.service';
import { UserService } from '../services/user.service';
import { User, UserAccessLevelType } from '../entities/user.model';

@Component({
    selector: "implement-templates",
    templateUrl: './implement-templates.component.html',
    styleUrls: ['./implement-templates.component.scss']
})
export class ImplementTemplatesComponent {
    pageTitle: string = "Implement Templates";
    pageSubTitle: string = "Use this page to edit and create new implement templates for your inspections. ";
    getImplementTemplates: ImplementTemplate[] = [];
    dumpBodyImplementTemplates: ImplementTemplate[] = [];
    userIsGlobalAdmin: boolean = false;

    constructor(private _appService: AppService, private _userService: UserService, private _implementTemplateService: ImplementTemplateService) { }

    ngOnInit() {
        this._appService.setPageTitle(this.pageTitle);
       // this._appService.setPageSubTitle(this.pageSubTitle);
        this._userService.getCurrentUser().subscribe(result => {
            this.userIsGlobalAdmin = result.AccessLevel == UserAccessLevelType.GlobalAdministrator ? true : false;
            this._implementTemplateService.getTemplateListForUser().subscribe(response => {
                response.map(template => {
                    template.ShowTemplate = true;
                    if (template.ImplementCategory == ImplementCategory.DumpBody)
                        this.dumpBodyImplementTemplates.push(template);
                    else
                        this.getImplementTemplates.push(template);
                })
            });
        });
    }

    searchKeywordChanged(keyword) {
        // GET
        for (var i = 0; i < this.getImplementTemplates.length; i++) {
            var customerName = this.getImplementTemplates[i].CustomerName;
            var templateName = this.getImplementTemplates[i].TemplateName;

            if (customerName == null) {
                customerName = "";
            }
            if (templateName == null) {
                templateName = "";
            }

            if ((customerName.includes(keyword)) || (templateName.includes(keyword))) {
                this.getImplementTemplates[i].ShowTemplate = true;
            } else {
                this.getImplementTemplates[i].ShowTemplate = false;
            }
        }

        // Dump Body
        for (var j = 0; j < this.dumpBodyImplementTemplates.length; j++) {
            var customerName = this.dumpBodyImplementTemplates[j].CustomerName;
            var templateName = this.dumpBodyImplementTemplates[j].TemplateName;

            if (customerName == null) {
                customerName = "";
            }
            if (templateName == null) {
                templateName = "";
            }

            if ((customerName.includes(keyword)) || (templateName.includes(keyword))) {
                this.dumpBodyImplementTemplates[j].ShowTemplate = true;
            } else {
                this.dumpBodyImplementTemplates[j].ShowTemplate = false;
            }
        }
    }
}
